module.exports = "/_next/static/images/ama-modal-247721696c56fd13442d1e47aab7c70a.png";